<div class="system-content">
    <mat-card class="system-content-card" [style.max-width.px]="cardWidth">
      <mat-card-content class="system-content-card-content">
        <div class="system-content-iad-logo"></div>
        <router-outlet></router-outlet>
      </mat-card-content>
    </mat-card>
</div>
